module.exports = __webpack_public_path__ + "static/empty_n_pc.033e8fc1.png";